<template>
  <main class="grid" style="opacity: 0; visibility: hidden;">
    <div class="container">
      <Slider :data="data"/>
    </div>
  </main>
</template>

<script>
import Slider from '@/components/Slider.vue';

export default {
  name: 'Home',

  components: {
    Slider,
  },

  computed: {
    data() {
      const { motorcycles } = this.$store.state.firebase;
      motorcycles.sort((a, b) => a.order - b.order);
      return motorcycles;
    },
  },
};
</script>

<style lang="scss" scoped>
main {
  min-height: 100vh;
}
</style>
